import containerFuild from '../html-snippets/container-fuild';
import css from '../css-snippets/section-harrybox-yuri';
const html = `
<div data-show-title="true" data-attribute="title-card" class="title-card">
  <h2>Collagen Night Wrapping Mask</h2>
  <p>Experience visibly smoother, firmer skin within hours—thanks to our breakthrough formula with 3X more
    ultra-absorbable collagen.</p>
</div>
<div data-background-icon="#cb6387" data-attribute="list-item" class="list-item" style="--background-icon: #cb6387;">
  <div data-attribute="item" class="wrap-item">
    <div class="icon-left">
      <img data-attribute="icon-item"
        src="https://cdn.skyfastimg.com/images/2026/04/28/image-69f03b058d85ee6109df5e33.png?w=50&h=50&q=80" alt="">
    </div>
    <div data-attribute="text-item" class="text-right-item">
      <p>Fades dark spots and sun damage</p>
    </div>
  </div>
  <div data-attribute="item" class="wrap-item">
    <div class="icon-left">
      <img data-attribute="icon-item"
        src="https://cdn.skyfastimg.com/images/2026/04/28/image-69f03b058d85ee6109df5e33.png?w=50&h=50&q=80" alt="">
    </div>
    <div data-attribute="text-item" class="text-right-item">
      <p>Fades dark spots and sun damage</p>
    </div>
  </div>
  <div data-attribute="item" class="wrap-item">
    <div class="icon-left">
      <img data-attribute="icon-item"
        src="https://cdn.skyfastimg.com/images/2026/04/28/image-69f03b058d85ee6109df5e33.png?w=50&h=50&q=80" alt="">
    </div>
    <div data-attribute="text-item" class="text-right-item">
      <p>Fades dark spots and sun damage</p>
    </div>
  </div>
  <div data-attribute="item" class="wrap-item">
    <div class="icon-left">
      <img data-attribute="icon-item"
        src="https://cdn.skyfastimg.com/images/2026/04/28/image-69f03b058d85ee6109df5e33.png?w=50&h=50&q=80" alt="">
    </div>
    <div data-attribute="text-item" class="text-right-item">
      <p>Fades dark spots and sun damage</p>
    </div>
  </div>

</div>
`;
export default containerFuild(html, css);
